const academicLevelOptions = [
  {
    label: "Bac +3",
    value: "Bac +3"
  },
  {
    label: "Bac +4",
    value: "Bac +4"
  },
  {
    label: "Bac +5 ou +",
    value: "Bac +5 ou +"
  }
]

export { academicLevelOptions }
